import React from 'react';
import { ProgressBar } from 'react-bootstrap';

export const IstProgressYear = (props) => {
    if (props.value.toString().length > 0) {
        return (
            <ProgressBar max={100} now={props.value} label={`${props.value}%`} />
        );
    }
    return ("Loading..");
};

